export default "__VITE_ASSET__DTfSMWeK__"